import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { MessageSquareText, Copy, Send } from "lucide-react";
import { toast } from "sonner";
import api from "@/api";

const TEMPLATES = [
  { k: "motivate", title: "رسالة تحفيز", text: "السلام عليكم ورحمة الله\nالأستاذ/ة {coord} — منسق/ة التطوع في {school}\nنثمّن جهودكم المميزة في العمل التطوعي، ونتطلع لمواصلة الإنجاز ورفع نسبة مشاركة الطلاب نحو المستهدف (90%). بالتوفيق دائماً." },
  { k: "reminder", title: "تنبيه موعد التقارير", text: "السلام عليكم ورحمة الله\nالأستاذ/ة {coord} — {school}\nنذكّركم بأهمية تحديث الفرص التطوعية واعتماد ساعات الطلاب المشاركين في ملف الإنجاز التطوعي قبل موعد رفع التقرير. شاكرين تعاونكم." },
  { k: "inactive", title: "متابعة مدرسة متأخرة", text: "السلام عليكم ورحمة الله\nالأستاذ/ة {coord} — {school}\nلاحظنا عدم تسجيل نشاط تطوعي في المنصة خلال الأيام الماضية. نأمل إدخال الفرص المنفذة وتسجيل الطلاب المشاركين، ونحن جاهزون لأي دعم تحتاجونه." },
  { k: "thanks", title: "شكر لمدرسة متميزة", text: "السلام عليكم ورحمة الله\nالأستاذ/ة {coord} — {school}\nنتقدم لكم بخالص الشكر والتقدير على تميزكم في العمل التطوعي وتحقيق مؤشرات متقدمة. أنتم قدوة مشرّفة، وفقكم الله." },
  { k: "visit", title: "إشعار بزيارة", text: "السلام عليكم ورحمة الله\nالأستاذ/ة {coord} — {school}\nنفيدكم بزيارة إشرافية قريبة لمتابعة برنامج العمل التطوعي والمسؤولية المجتمعية. نأمل تجهيز شواهد الفرص المنفذة. شاكرين لكم." },
];

const waPhone = (p) => { const d = (p || "").replace(/\D/g, ""); return d.startsWith("05") ? `966${d.slice(1)}` : d; };

export const MessageBank = ({ school, onClose }) => {
  const [sel, setSel] = useState(TEMPLATES[0].k);
  const fill = (t) => t.replace(/{coord}/g, school?.coordinator_name || "منسق التطوع").replace(/{school}/g, school?.name || "المدرسة");
  const text = fill(TEMPLATES.find((t) => t.k === sel).text);
  const logSent = () => { if (school?.id) api.post("/my-messages", { school_id: school.id }).catch(() => {}); };
  const copy = async () => {
    try { await navigator.clipboard.writeText(text); toast.success("تم نسخ الرسالة"); logSent(); }
    catch { toast.error("تعذّر النسخ — انسخ النص يدوياً"); }
  };
  const phone = waPhone(school?.coordinator_phone);

  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="glass border-amber-400/30 text-stone-800 max-w-lg max-h-[92vh] overflow-y-auto" dir="rtl" data-testid="message-bank">
        <DialogHeader><DialogTitle className="gold-text font-head flex items-center gap-2"><MessageSquareText size={18} /> بنك الرسائل الجاهزة</DialogTitle></DialogHeader>
        {school && <div className="text-xs text-stone-500">إلى: {school.coordinator_name || "منسق التطوع"} — {school.name}</div>}
        <div className="flex flex-wrap gap-1.5">
          {TEMPLATES.map((t) => (
            <button key={t.k} type="button" data-testid={`msg-tpl-${t.k}`} onClick={() => setSel(t.k)}
              className={`px-3 py-1.5 rounded-full text-xs border transition-colors ${sel === t.k ? "bg-sky-600 text-white border-sky-600" : "bg-white border-sky-300/50 text-stone-700"}`}>{t.title}</button>
          ))}
        </div>
        <pre data-testid="msg-text" className="whitespace-pre-wrap font-body text-sm bg-amber-50 border border-amber-400/30 rounded-xl p-3 leading-7">{text}</pre>
        <div className="flex flex-wrap gap-2">
          <button data-testid="msg-copy" onClick={copy} className="btn-gold px-4 py-2 rounded-xl flex items-center gap-2"><Copy size={15} /> نسخ</button>
          {phone && <a data-testid="msg-whatsapp" href={`https://wa.me/${phone}?text=${encodeURIComponent(text)}`} target="_blank" rel="noreferrer" onClick={logSent}
            className="px-4 py-2 rounded-xl bg-emerald-600 text-white flex items-center gap-2 hover:bg-emerald-700"><Send size={15} /> إرسال واتساب</a>}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MessageBank;
